import { fromJS } from 'immutable';
import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_FORM_STATE,
} from './constants';

// Helper to generate initial state fields for each health sub-question
function buildHealthSubQuestionFields(prefix) {
  return {
    [`${prefix}SelectedExpenses`]: [],
    [`${prefix}ChangeFeeOption`]: '',
    [`${prefix}NonRefundablePrePaidTravelCostsItems`]: [],
    [`${prefix}NonRefundablePrePaidTransportationCostsItems`]: [],
    [`${prefix}CommercialAccommodationToResumeTravelItems`]: [],
    [`${prefix}ChangeFeesIfCancellingPortionOfTripItems`]: [],
    [`${prefix}SingleSupplementItems`]: [],
  };
}

const HEALTH_SUB_QUESTION_PREFIXES = [
  'youOrTravellingCompanion',
  'familyMember',
  'businessPartnerOrEmployer',
  'hostAtDestination',
];

const PREGNANCY_ADOPTION_SUB_QUESTION_PREFIXES = [
  'legalAdoption',
  'pregnancyDiagnosed',
  'complicationsOfPregnancy',
];

const EMPLOYMENT_EDUCATION_SUB_QUESTION_PREFIXES = [
  'jobTransfer',
  'involuntaryLossOfEmployment',
  'cancellationOfBusinessMeeting',
  'cancellationOfConference',
];

const LEGAL_ISSUES_SUB_QUESTION_PREFIXES = [
  'canadianGovernmentAdvisory',
  'juryDutyCourtProceeding',
  'summonedToService',
  'officialTravelAdvisory',
  'nonIssuanceOfVisa',
];

const CARRIER_ACCIDENT_WEATHER_SUB_QUESTION_PREFIXES = [
  'missedConnection',
  'fourHoursNoConnection',
  'cancellationOfCommonCarrier',
  'tourOperatorCancellation',
  'accidentOnWay',
  'delayOfPrivateVehicle',
];

const OTHER_REASONS_SUB_QUESTION_PREFIXES = [
  'naturalDisaster',
  'unforeseeableEvent',
];

// Helper to generate tour-specific state fields (for tour operator cancellation sub-question)
function buildTourSubQuestionFields(prefix) {
  return {
    [`${prefix}NonRefundablePrePaidTourCostsItems`]: [],
    [`${prefix}NonRefundablePrePaidTransportationCostsNotPartOfTourItems`]: [],
  };
}

const initialState = fromJS({
  form: {
    cancelledBeforeLeaving: '',
    changedAfterLeaving: '',

    whatExpensesAreYouClaimingFor: [],
    descriptionOfLoss: '',
    amountClaimed: '',

    // Health sub-questions: array of selected sub-question keys
    healthSubQuestions: [],

    // Per health sub-question expense data
    ...HEALTH_SUB_QUESTION_PREFIXES.reduce((acc, prefix) => ({
      ...acc,
      ...buildHealthSubQuestionFields(prefix),
    }), {}),

    // Pregnancy/adoption sub-questions: array of selected sub-question keys
    pregnancyAdoptionSubQuestions: [],

    // Per pregnancy/adoption sub-question expense data
    ...PREGNANCY_ADOPTION_SUB_QUESTION_PREFIXES.reduce((acc, prefix) => ({
      ...acc,
      ...buildHealthSubQuestionFields(prefix),
    }), {}),

    // Employment/education sub-questions: array of selected sub-question keys
    employmentEducationSubQuestions: [],

    // Per employment/education sub-question expense data
    ...EMPLOYMENT_EDUCATION_SUB_QUESTION_PREFIXES.reduce((acc, prefix) => ({
      ...acc,
      ...buildHealthSubQuestionFields(prefix),
    }), {}),

    // Legal issues sub-questions: array of selected sub-question keys
    legalIssuesSubQuestions: [],

    // Per legal issues sub-question expense data
    ...LEGAL_ISSUES_SUB_QUESTION_PREFIXES.reduce((acc, prefix) => ({
      ...acc,
      ...buildHealthSubQuestionFields(prefix),
    }), {}),

    // Carrier/accident/weather sub-questions: array of selected sub-question keys
    carrierAccidentWeatherSubQuestions: [],

    // Per carrier/accident/weather sub-question expense data
    ...CARRIER_ACCIDENT_WEATHER_SUB_QUESTION_PREFIXES.reduce((acc, prefix) => ({
      ...acc,
      ...buildHealthSubQuestionFields(prefix),
    }), {}),

    // Tour-specific expense item fields for tourOperatorCancellation
    ...buildTourSubQuestionFields('tourOperatorCancellation'),

    // Other reasons sub-questions: array of selected sub-question keys
    otherReasonsSubQuestions: [],

    // Per other reasons sub-question expense data
    ...OTHER_REASONS_SUB_QUESTION_PREFIXES.reduce((acc, prefix) => ({
      ...acc,
      ...buildHealthSubQuestionFields(prefix),
    }), {}),
  },
  errors: [],
});

function handleFormReset(state, { fields }) {
  let newState = state;
  fields.forEach((field) => {
    const defaultValue = initialState.getIn(['form', field]);
    newState = newState.setIn(['form', field], defaultValue);
  });
  return newState;
}

function stepTripCancellationTugoReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload ? fromJS({ form: action.payload, errors: [] }) : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_FORM_STATE:
      return handleFormReset(state, action.payload);
    default:
      return state;
  }
}

export { HEALTH_SUB_QUESTION_PREFIXES, PREGNANCY_ADOPTION_SUB_QUESTION_PREFIXES, EMPLOYMENT_EDUCATION_SUB_QUESTION_PREFIXES, LEGAL_ISSUES_SUB_QUESTION_PREFIXES, CARRIER_ACCIDENT_WEATHER_SUB_QUESTION_PREFIXES, OTHER_REASONS_SUB_QUESTION_PREFIXES, buildHealthSubQuestionFields, buildTourSubQuestionFields };
export default stepTripCancellationTugoReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.TripCancellation/reducer.js